import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _curry from 'lodash/curry';
import _includes from 'lodash/includes';
import _head from 'lodash/head';
import _map from 'lodash/map';

// utils
import castArrayIfPresent from '@tekion/tekion-base/utils/castArrayIfPresent';

// constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import PRESET_IDS from '../../../../../molecules/dateRange/constants/dateRange.presetIds';
import FILTER_TYPES from '../../../constants/filterSection.filterTypes';

// helpers
import { getPresetList } from '../../../../../molecules/dateRange';
import getTypeOfFilter from '../../../helpers/filterSection.typeOfFilter';

// reader
import filterGroupReader, { filterReader } from '../../../readers/FilterGroup';
var isPresetPresentInDateFilter = function isPresetPresentInDateFilter(dateFilterValues) {
  var firstValue = _head(dateFilterValues);
  return _includes(PRESET_IDS, firstValue);
};
var getDateRangeForPreset = function getDateRangeForPreset(filterValues) {
  var presetId = _head(filterValues);
  var dateRangesByPreset = getPresetList() || EMPTY_OBJECT;
  var presetDateRange = dateRangesByPreset[presetId] || EMPTY_ARRAY;
  var _presetDateRange = _slicedToArray(presetDateRange, 2),
    startTimeMoment = _presetDateRange[0],
    endTimeMoment = _presetDateRange[1];
  var dateRangeForPreset = [+startTimeMoment, +endTimeMoment];
  return dateRangeForPreset;
};
var makeDateFilterWithPreset = function makeDateFilterWithPreset(filterValues) {
  var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  var dateRangeForPreset = getDateRangeForPreset(filterValues);
  var presetId = _head(filterValues);
  var dateFilterWithPreset = _objectSpread(_objectSpread({}, filter), {}, {
    values: dateRangeForPreset,
    additional: castArrayIfPresent(presetId)
  });
  return dateFilterWithPreset;
};
export var getUpdatedDateFilter = function getUpdatedDateFilter(filter) {
  var filterValues = filterReader.values(filter);
  var isPresetPresent = isPresetPresentInDateFilter(filterValues);
  if (!isPresetPresent) {
    return filter;
  }
  var dateFilterWithPreset = makeDateFilterWithPreset(filterValues, filter);
  return dateFilterWithPreset;
};
var mapDatePresetToEpochInDateFilter = _curry(function (filterTypes, filter) {
  var type = getTypeOfFilter(filterTypes, filter);
  if (type === FILTER_TYPES.DATE) {
    var updatedDateFilter = getUpdatedDateFilter(filter);
    return updatedDateFilter;
  }
  return filter;
});

/**
 *
 * @param filters - filters are expected be to be the filters that the component expects
 * @param filterTypes - filterTypes are the once created locally and passed as per the structure defined in filters
 * @returns {Array} - filters with updated date filter
 */

var getFiltersWithUpdatedDateFilter = function getFiltersWithUpdatedDateFilter(filters, filterTypes) {
  var updatedFilters = _map(filters, mapDatePresetToEpochInDateFilter(filterTypes));
  return updatedFilters;
};
var updateDateFilterInFilterGroup = function updateDateFilterInFilterGroup(filterTypes) {
  return function () {
    var filterGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
    var filters = filterGroupReader.filters(filterGroup);
    var updatedFilters = getFiltersWithUpdatedDateFilter(filters, filterTypes);
    return _objectSpread(_objectSpread({}, filterGroup), {}, {
      filters: updatedFilters
    });
  };
};
export var getFilterGroupListWithUpdatedDateFilter = function getFilterGroupListWithUpdatedDateFilter(filterGroupList, filterTypes) {
  var updatedFilterGroupList = _map(filterGroupList, updateDateFilterInFilterGroup(filterTypes));
  return updatedFilterGroupList;
};
export default getFiltersWithUpdatedDateFilter;